import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import * as models from "./model";
import { sraCustomerApi } from "./sraCustomerApi";

import { push } from "redux-little-router";

export type SraCustomerAction =
      ({ type: typeof actions.LOAD_SRACUSTOMERS_SUCCESS } & Payload<models.SraCustomerListModel[]>)
    | ({ type: typeof actions.CREATE_SRACUSTOMER_SUCCESS } & Payload<models.SraCustomerDetailModel>)
    | ({ type: typeof actions.LOAD_SRACUSTOMER_DETAIL_SUCCESS } & Payload<models.SraCustomerDetailModel>)
    | ({ type: typeof actions.SAVE_SRACUSTOMER_SUCCESS } & Payload<models.SraCustomerDetailModel>)
    | ({ type: typeof actions.DELETE_SRACUSTOMER_SUCCESS } & Payload<any>)
    | ({ type: typeof actions.DEACTIVATE_SRA_CUSTOMER_SUCCESS } & Payload<models.SraCustomerDetailModel>)
    | ({ type: typeof actions.ACTIVATE_SRA_CUSTOMER_SUCCESS } & Payload<models.SraCustomerDetailModel>);

export const loadSraCustomersSuccess = (payload: models.SraCustomerListModel[]): SraCustomerAction => ({
    payload,
    type: actions.LOAD_SRACUSTOMERS_SUCCESS
});

export const createSraCustomerSuccess = (payload: models.SraCustomerDetailModel): SraCustomerAction => ({
    payload,
    type: actions.CREATE_SRACUSTOMER_SUCCESS
});

export const saveSraCustomerSuccess = (payload: models.SraCustomerDetailModel): SraCustomerAction => ({
    payload,
    type: actions.SAVE_SRACUSTOMER_SUCCESS
});

export const deleteSraCustomerSuccess = (id: any): SraCustomerAction => ({
    payload: id,
    type: actions.DELETE_SRACUSTOMER_SUCCESS
});

export const activateSraCustomerSuccess = (payload: models.SraCustomerDetailModel): SraCustomerAction => ({
    payload,
    type: actions.ACTIVATE_SRA_CUSTOMER_SUCCESS
});

export const deactivateSraCustomerSuccess = (payload: models.SraCustomerDetailModel): SraCustomerAction => ({
    payload,
    type: actions.DEACTIVATE_SRA_CUSTOMER_SUCCESS
});

export function createSraCustomer(sraCustomer: models.SraCustomerCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "createSraCustomer", sraCustomerApi.create(sraCustomer));
        dispatch(createSraCustomerSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveSraCustomer(sraCustomer: models.SraCustomerEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "saveSraCustomer", sraCustomerApi.save(sraCustomer));

        dispatch(saveSraCustomerSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteSraCustomer(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteSraCustomer", sraCustomerApi.delete(id));
        dispatch(deleteSraCustomerSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export const activateSraCustomer = (id: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.ACTIVATE_SRA_CUSTOMER, sraCustomerApi.activate(id));
        dispatch(activateSraCustomerSuccess(result));
    };
};

export const deactivateSraCustomer = (id: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.DEACTIVATE_SRA_CUSTOMER, sraCustomerApi.deactivate(id));
        dispatch(deactivateSraCustomerSuccess(result));
    };
};

export function loadSraCustomers() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadSraCustomers", sraCustomerApi.getAll());
        dispatch(loadSraCustomersSuccess(result));
    };
}

export const loadSraCustomerDetailSuccess = (sraCustomer: models.SraCustomerDetailModel) => ({
    payload: sraCustomer,
    type: actions.LOAD_SRACUSTOMER_DETAIL_SUCCESS
});

export function loadSraCustomerDetail({ sraCustomerId }: { sraCustomerId: string}) {
    return async  (dispatch: Dispatch, getState: () => models.AppState) => {
        const sraCustomer = getState().sraCustomers.filter(c => c.id === sraCustomerId)[0];

        if (sraCustomer === undefined
            || sraCustomer.detailUpdated === undefined
            || sraCustomer.detailUpdated.isBefore(sraCustomer.listUpdated)) {

            const result = await loadAndTrack(dispatch, "loadSraCustomerDetail", sraCustomerApi.detail(sraCustomerId));
            dispatch(loadSraCustomerDetailSuccess(result));
        }
    };
}
